"use client";

import { Skeleton } from "../ui/skeleton";
import type { CourseLoadingProps } from "./course-loading.types";

/** Keep the drawer stable without interactive fields until the saved profile is known. */
export function CourseEnquirySkeleton({ label }: CourseLoadingProps) {
  return (
    <div role="status" aria-label={label} aria-busy="true">
      <span className="sr-only">{label}</span>
      <div
        aria-hidden="true"
        className="space-y-4 motion-reduce:[&_.animate-pulse]:animate-none"
      >
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <div className="space-y-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-1">
          <Skeleton className="h-4 w-24" />
          <div className="flex gap-2">
            <Skeleton className="h-10 w-24 shrink-0" />
            <Skeleton className="h-10 flex-1" />
          </div>
        </div>
        <div className="space-y-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <Skeleton className="h-6 w-full" />
        <Skeleton className="h-11 w-full" />
      </div>
    </div>
  );
}
